import { Link } from 'react-router-dom';
import { works } from '@/mocks/works';

const entries = [
  {
    type: 'tv' as const,
    title: '电视剧',
    desc: '都市 · 悬疑 · 历史 · 古装',
    icon: 'ri-tv-2-line',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20warm%20living%20room%20scene%20with%20a%20large%20glowing%20television%20screen%2C%20amber%20ambient%20light%20and%20deep%20blue%20shadows%2C%20cozy%20modern%20editorial%20film%20still%2C%20high%20detail&width=800&height=600&seq=cat-tv-entry&orientation=landscape',
    count: works.filter((w) => w.type === 'tv').length,
  },
  {
    type: 'movie' as const,
    title: '电影',
    desc: '科幻 · 剧情 · 动作 · 爱情',
    icon: 'ri-movie-2-line',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20glowing%20amber%20screen%20light%20and%20deep%20blue%20seats%2C%20atmospheric%20editorial%20film%20still%2C%20high%20detail&width=800&height=600&seq=cat-movie-entry&orientation=landscape',
    count: works.filter((w) => w.type === 'movie').length,
  },
];

export default function CategoryEntries() {
  return (
    <section className="px-4 md:px-8 py-10 md:py-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-10 h-10 rounded-lg bg-primary-50 text-primary-600 flex items-center justify-center text-xl">
            <i className="ri-apps-2-line" aria-hidden="true"></i>
          </span>
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              分类快捷入口
            </h2>
            <p className="mt-0.5 text-xs md:text-sm text-foreground-500">
              快速进入电视剧或电影频道
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-product-shop>
          {entries.map((entry) => (
            <Link
              key={entry.type}
              to={`/category/${entry.type}`}
              className="group relative h-52 md:h-56 rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src={entry.image}
                alt={`${entry.title}频道`}
                title={`${entry.title}分类入口`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/90 via-secondary-950/50 to-secondary-950/10"></div>
              <div className="absolute inset-0 p-6 flex flex-col justify-between">
                <span className="w-12 h-12 rounded-lg bg-accent-500 text-secondary-950 flex items-center justify-center text-2xl">
                  <i className={entry.icon} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="font-heading text-2xl font-bold text-background-50">
                    {entry.title}频道
                  </h3>
                  <p className="mt-1 text-sm text-background-200">{entry.desc}</p>
                  <p className="mt-3 inline-flex items-center gap-1 text-xs text-accent-400">
                    共 {entry.count} 部作品
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}